import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogActions, DialogContent,
  TextField, MenuItem, Button, Grid, Typography,
  Checkbox, FormControlLabel,
} from "@material-ui/core";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import axios from "../../../config/axios";
import { getCustomers } from "redux/action/customer.action";

const FREQUENCIES = [
  { value: "monthly",   label: "Mensal" },
  { value: "quarterly", label: "Trimestral" },
  { value: "semester",  label: "Semestral" },
  { value: "annual",    label: "Anual" },
];

const DEFAULTS = {
  name: "", email: "", phone: "", nif: "",
  address: "", floor: "", city: "", zipcode: "",
  monthly_amount: "", payment_frequency: "quarterly",
  total_m2: "", price_version: "V02",
  subscription_start: new Date().toISOString().split("T")[0],
  months_paid: "3", notes: "",
  pickup_done: true,
};

export default function CreateManualClientDialog({ open, onClose }) {
  const [form, setForm] = useState(DEFAULTS);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const handleChange = (field) => (e) => { const v = e.target.value; setForm(f => ({ ...f, [field]: v })); };

  const handleSubmit = async () => {
    if (!form.name || !form.email) {
      enqueueSnackbar("Nome e email são obrigatórios.", { variant: "warning" });
      return;
    }
    setLoading(true);
    try {
      await axios.post("/admin/create-manual-client", {
        ...form,
        monthly_amount: parseFloat(form.monthly_amount) || 0,
        total_m2: parseFloat(form.total_m2) || null,
        months_paid: parseInt(form.months_paid, 10) || 1,
        pickup_done: form.pickup_done,
      });
      enqueueSnackbar("Cliente criado com sucesso.", { variant: "success" });
      dispatch(getCustomers({}));
      setForm(DEFAULTS);
      onClose();
    } catch (err) {
      enqueueSnackbar(err?.response?.data?.message || "Erro ao criar cliente.", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const field = (label, key, opts = {}) => (
    <Grid item xs={12} sm={opts.sm || 6}>
      <TextField
        fullWidth label={label} value={form[key]}
        onChange={handleChange(key)}
        variant="outlined" size="small"
        {...opts}
      />
    </Grid>
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Novo Cliente Manual</DialogTitle>
      <DialogContent>
        <Typography variant="caption" color="textSecondary" style={{ marginBottom: 16, display: "block" }}>
          Clientes faturados externamente (ex: InvoiceXpress) sem conta na app.
        </Typography>
        <Grid container spacing={2} style={{ marginTop: 4 }}>
          {field("Nome *", "name")}
          {field("Email *", "email", { type: "email" })}
          {field("Telefone", "phone")}
          {field("NIF", "nif")}
          {field("Morada", "address", { sm: 12 })}
          {field("Andar / Porta", "floor")}
          {field("Cidade", "city")}
          {field("Código Postal", "zipcode")}

          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ marginTop: 8, marginBottom: 4 }}>
              Subscrição
            </Typography>
          </Grid>

          {field("Valor mensal (€ c/IVA)", "monthly_amount", { type: "number" })}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth select label="Plano" value={form.payment_frequency}
              onChange={handleChange("payment_frequency")}
              variant="outlined" size="small"
            >
              {FREQUENCIES.map(f => (
                <MenuItem key={f.value} value={f.value}>{f.label}</MenuItem>
              ))}
            </TextField>
          </Grid>
          {field("Total m²", "total_m2", { type: "number" })}
          {field("Versão de preço", "price_version")}
          {field("Data de início", "subscription_start", { type: "date", InputLabelProps: { shrink: true } })}
          {field("Meses pagos", "months_paid", { type: "number" })}
          {field("Notas", "notes", { sm: 12, multiline: true, rows: 2 })}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={form.pickup_done}
                  onChange={e => { const v = e.target.checked; setForm(f => ({ ...f, pickup_done: v })); }}
                  color="primary"
                />
              }
              label="Recolha já foi feita (cliente já em armazém)"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" disabled={loading}>
          {loading ? "A criar..." : "Criar Cliente"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
